// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaReddit, FaDiscord, FaInstagram, FaFacebook, FaGamepad } from 'react-icons/fa';
import { FiLock, FiShield, FiUserCheck, FiActivity, FiCheckCircle } from 'react-icons/fi';
import cityImg from '../assets/fx/city.png';
import starsImg from '../assets/fx/stars.svg';

function FaXTwitter(props) {
  return <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" {...props}><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>;
}

// Señales de seguridad — basadas en el modelo real del producto (sin claims inventados)
const TRUST = [
  { Icon: FiUserCheck,   label: 'Vendedores verificados', sub: 'Solo comerciantes por invitación' },
  { Icon: FiLock,        label: 'Cifrado SSL / TLS',      sub: 'Conexión segura 256-bit' },
  { Icon: FiShield,      label: 'No custodiamos fondos',  sub: 'Operás P2P, vos controlás' },
  { Icon: FiActivity,    label: 'Reputación real',        sub: 'Ratings y trades públicos' },
];

const Footer = () => (
  <footer className="app-footer">
    {/* Banda de confianza / seguridad */}
    <div className="footer-trust">
      <div className="footer-trust-inner">
        {TRUST.map(({ Icon, label, sub }) => (
          <div key={label} className="footer-trust-item">
            <span className="footer-trust-ic"><Icon /></span>
            <span className="footer-trust-text">
              <strong>{label}</strong>
              <span>{sub}</span>
            </span>
          </div>
        ))}
      </div>
    </div>

    {/* Cuerpo */}
    <div className="footer-inner">

      {/* Marca */}
      <div className="footer-brand">
        <img src="/assets/Logo-White.png" alt="Bitplify" className="footer-logo-img footer-logo-dark" />
        <img src="/assets/Logo.png"       alt="Bitplify" className="footer-logo-img footer-logo-light" />
        <p className="footer-tagline">
          Intercambia crypto. Pon tu precio. Sube de nivel.
          <FaGamepad className="footer-tagline-icon" aria-hidden="true" />
        </p>

        <div className="footer-status">
          <span className="footer-status-dot" />
          <span>Todos los sistemas operativos</span>
        </div>

        <div className="footer-socials">
          <a href="https://twitter.com/Bitplify" target="_blank" rel="noopener noreferrer" className="social-x" title="X / Twitter"><FaXTwitter /></a>
          <a href="https://instagram.com/Bitplify" target="_blank" rel="noopener noreferrer" className="social-instagram" title="Instagram"><FaInstagram /></a>
          <a href="https://facebook.com/Bitplify" target="_blank" rel="noopener noreferrer" className="social-facebook" title="Facebook"><FaFacebook /></a>
          <a href="https://discord.gg/Bitplify" target="_blank" rel="noopener noreferrer" className="social-discord" title="Discord"><FaDiscord /></a>
          <a href="https://www.reddit.com/r/Bitplify" target="_blank" rel="noopener noreferrer" className="social-reddit" title="Reddit"><FaReddit /></a>
        </div>
      </div>

      {/* Producto */}
      <div className="footer-section">
        <h4 className="footer-heading">Producto</h4>
        <ul className="footer-links">
          <li><Link to="/">Marketplace</Link></li>
          <li><Link to="/create">Crear oferta</Link></li>
          <li><Link to="/portfolio">Portafolio</Link></li>
          <li><Link to="/rewards">Recompensas</Link></li>
        </ul>
      </div>

      {/* Soporte */}
      <div className="footer-section">
        <h4 className="footer-heading">Soporte</h4>
        <ul className="footer-links">
          <li><Link to="/faq">Preguntas frecuentes</Link></li>
          <li><Link to="/videos">Videos tutoriales</Link></li>
          <li><a href="https://discord.gg/Bitplify" target="_blank" rel="noopener noreferrer">Soporte en Discord</a></li>
          <li><a href="https://www.reddit.com/r/Bitplify" target="_blank" rel="noopener noreferrer">Comunidad en Reddit</a></li>
        </ul>
      </div>

      {/* Legal */}
      <div className="footer-section">
        <h4 className="footer-heading">Legal &amp; Seguridad</h4>
        <ul className="footer-links">
          <li><a href="/terms">Términos de servicio</a></li>
          <li><a href="/privacy">Política de privacidad</a></li>
          <li><Link to="/aml">Política AML / KYC</Link></li>
          <li><Link to="/security"><FiLock className="footer-link-ic" /> Centro de seguridad</Link></li>
        </ul>
      </div>

    </div>

    {/* Bottom bar */}
    <div className="footer-bottom">
      <div className="footer-bottom-left">
        <span className="footer-secure-pill"><FiCheckCircle /> Conexión segura</span>
        <span>© {new Date().getFullYear()} Bitplify. Todos los derechos reservados.</span>
      </div>
      <p className="footer-disclaimer">
        Operar con criptomonedas conlleva riesgo. Bitplify es un mercado P2P y no custodia tus fondos.
      </p>
      <div className="footer-bottom-links">
        <a href="/terms">Términos</a>
        <a href="/privacy">Privacidad</a>
        <Link to="/faq">Ayuda</Link>
        <span className="footer-region">🌎 LATAM · ES</span>
      </div>
    </div>

    {/* Skyline cyberpunk: el footer "vive dentro" de la ciudad (solo modo oscuro) */}
    <div
      className="footer-skyline"
      style={{ '--ftcity': `url(${cityImg})`, '--ftstars': `url(${starsImg})` }}
      aria-hidden="true"
    >
      <div className="footer-sky-stars" />
    </div>
  </footer>
);

export default Footer;
